import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'errorMessage',
    'input',
    'list',
    'listErrorMessage',
    'modal',
    'select',
    'template',
    'value',
  ];

  connect() {
    this.csrfParam = document.querySelector(
      "head meta[name='csrf-param']"
    ).content;

    this.csrfToken = document.querySelector(
      "head meta[name='csrf-token']"
    ).content;

    const baseUrl = this.element.closest('form').action;
    const fieldID = this.data.get('id');
    this.updateUrl = `${baseUrl}/form_fields/${fieldID}`;
  }

  add() {
    this._clearErrors();

    if (!this.inputTargets.every(this._validInput.bind(this))) {
      this._showErrors();
      return;
    }

    const newValue = [...this.currentValue, this._structuredValue()];
    this._updateRemote(newValue);
  }

  delete(event) {
    const { structuredFieldItemId } = event.target.dataset;
    const newValue = this.currentValue.filter(
      row => parseInt(row._id) !== parseInt(structuredFieldItemId)
    );

    this._updateRemote(newValue);
  }

  get modal() {
    return this.application.getControllerForElementAndIdentifier(
      this.modalTarget,
      'modal'
    );
  }

  new() {
    this.inputTargets.forEach(input => {
      if (input.type && (input.type === 'radio' || input.type === 'checkbox')) {
        input.checked = false;
      } else {
        input.value = '';
      }
    });
    this.modal.open();
  }

  _updateRemote(newValue) {
    const body = JSON.stringify({
      form_value: { value: newValue },
      [this.csrfParam]: this.csrfToken,
    });

    fetch(this.updateUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body,
    })
      .then(res => res.text())
      .then(html => {
        const fragment = document.createRange().createContextualFragment(html);
        this.element.parentNode.replaceChild(fragment, this.element);
      });
  }

  _clearErrors() {
    this.element.querySelectorAll('.o-form-field--error').forEach(input => {
      input.classList.remove('o-form-field--error');
    });
    this.errorMessageTargets.forEach(target => target.remove());
  }

  _showErrors() {
    this.inputTargets
      .filter(input => !this._validInput(input))
      .forEach(input => {
        this._showError(
          input,
          input.validationMessage || 'Please fill in this field.'
        );
      });
  }

  _showError(input, errorMessage) {
    const formField = input.closest('.o-form-field');
    formField.classList.add('o-form-field--error');

    if (!formField.querySelector('.error-message')) {
      formField.insertAdjacentHTML(
        'beforeend',
        `<p class="error-message" data-target="structured-field.errorMessage">
        ${errorMessage}
      </p>`
      );
    }
  }

  _structuredValue() {
    return Object.assign(
      { _id: new Date().getTime() },
      ...this.inputTargets.map(this._valueForTarget)
    );
  }

  _validInput(input) {
    if (input.type === 'hidden') {
      return input.value.length > 0;
    } else if (input.type === 'radio') {
      return (
        this.inputTargets.filter(t => t.name === input.name && t.checked)
          .length > 0
      );
    } else {
      return input.validity.valid;
    }
  }

  _valueForTarget(target, i, array) {
    const targetName = target.name.match(/^field-\d+-(.+)$/)[1];
    if (target.type === 'radio' && !target.checked) {
      return null;
    } else {
      return {
        [targetName]: target.value,
      };
    }
  }

  get currentValue() {
    return this.valueTarget.value.length
      ? JSON.parse(this.valueTarget.value)
      : [];
  }
}
